import React from "react";
import { LedgerArticle } from "../../data/ledger";
type LedgerListProps = {
  articles: LedgerArticle[];
};
const headers = [{
  label: "Date",
  span: "md:col-span-2"
}, {
  label: "Category",
  span: "md:col-span-2"
}, {
  label: "Headline",
  span: "md:col-span-5"
}, {
  label: "Type",
  span: "md:col-span-2"
}, {
  label: "Read",
  span: "md:col-span-1 md:text-right"
}];
export function LedgerList({
  articles
}: LedgerListProps) {
  return <div className="border-t border-navy" data-id="element-416" data-mp="2dwkk5l98z3in">
      <div aria-hidden className="hidden grid-cols-12 gap-x-6 border-b border-stone py-4 md:grid" data-id="element-417" data-mp="2hzyzsat9xhvk">
        {headers.map(h => <span key={h.label} className={`eyebrow text-oxblood ${h.span}`} data-id="element-418" data-mp="240zmfzb7opep">
            {h.label}
          </span>)}
      </div>
      <ul data-id="element-419" data-mp="290m1mealofq5">
        {articles.map(a => <li key={a.id} className="grid grid-cols-12 gap-x-6 gap-y-2 border-b border-stone py-7" data-id="element-420" data-mp="281q3ti87ep0">
            <span className="col-span-6 text-sm tabular-nums text-charcoal/65 md:col-span-2" data-id="element-421" data-mp="77nztsyuict2">{a.date}</span>
            <span className="col-span-6 text-sm font-medium text-oxblood md:col-span-2" data-id="element-422" data-mp="1mcf860ydngw2">{a.topic}</span>
            <div className="col-span-12 md:col-span-5" data-id="element-423" data-mp="1hdkoyxwhzqbf">
              <h3 className="font-display text-2xl leading-snug text-navy" data-id="element-424" data-mp="1v5is8s3j2rzo">{a.title}</h3>
              <p className="mt-2 text-[15px] leading-relaxed text-charcoal/70" data-id="element-425" data-mp="1r45l8eop8ir6">{a.dek}</p>
            </div>
            <span className="col-span-6 text-sm text-charcoal/65 md:col-span-2" data-id="element-426" data-mp="13ekxzjliizc3">{a.format}</span>
            <span className="col-span-6 text-right text-sm tabular-nums text-charcoal/65 md:col-span-1" data-id="element-427" data-mp="yfhwua8nld9e">
              {a.readTime}
            </span>
          </li>)}
      </ul>
    </div>;
}